import { useEffect, useState } from 'react';

function getExistingScript(src: string) {
  if (typeof document === 'undefined') return undefined;

  const scripts = Array.from(document.scripts);
  return scripts.find((script) => script.src === src);
}

function useScript(src: string): [boolean] {
  const [ready, setReady] = useState(
    () => getExistingScript(src)?.dataset.loaded === 'true',
  );

  useEffect(() => {
    const existingScript = getExistingScript(src);

    if (existingScript?.dataset.loaded === 'true') {
      setReady(true);
      return;
    }

    const script = existingScript || document.createElement('script');

    const handleLoad = () => {
      script.dataset.loaded = 'true';
      setReady(true);
    };

    script.addEventListener('load', handleLoad);

    if (!existingScript) {
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      script.removeEventListener('load', handleLoad);
    };
  }, [src]);

  return [ready];
}

export default useScript;
